module.exports = __webpack_public_path__ + "media/images/icon_foal_mare_small-4b2544ed5a3f0b1f119a40d9346a4851.png";